module.exports = __webpack_public_path__ + "img/2566-09-04 10.06.00.7e49ec3d.jpg";